import React from 'react'

function SwivelJet() {
    return (
        <embed src="\pdfs\E1.2.3.1_DW-V2_Swivel_jet_nozzle_01.2014_kr.pdf" width="100%" height="2100px" />
    )
}

export default SwivelJet